import { makeAutoObservable } from "mobx";
import { NovaStore } from "./NovaStore";

export class NovaLocalStore {
  instanceId: string;
  isMinimized: boolean = false;
  position: { x: number; y: number } = { x: 0, y: 0 };
  props: any = {};

  private novaStore: NovaStore;

  constructor(instanceId: string) {
    this.instanceId = instanceId;

    this.position = this.getDefaultPosition();

    this.novaStore = new NovaStore();

    makeAutoObservable(this);
  }

  get currentWorkflow() {
    return this.novaStore.currentWorkflow;
  }

  get isTyping() {
    return this.novaStore.isTyping;
  }

  get currentMessage() {
    return this.novaStore.currentMessage;
  }

  get messages() {
    return this.novaStore.messages;
  }

  get loading() {
    return this.novaStore.loading;
  }

  get isGenerating() {
    return this.novaStore.isGenerating;
  }

  get workflowContext() {
    return this.novaStore.workflowContext;
  }

  get uploadedFile() {
    return this.novaStore.uploadedFile;
  }

  get encryptedFile() {
    return this.novaStore.encryptedFile;
  }

  initializeWorkflow() {
    return this.novaStore.initializeWorkflow();
  }

  async streamMessage(message: string, speed: number = 50) {
    return this.novaStore.streamMessage(message, speed);
  }

  addMessage(role: "user" | "assistant", content: string) {
    return this.novaStore.addMessage(role, content);
  }

  setGenerating(generating: boolean) {
    return this.novaStore.setGenerating(generating);
  }

  async processUserInput(message: string) {
    return this.novaStore.processUserInput(message);
  }

  async handleFileUpload(file: File) {
    return this.novaStore.handleFileUpload(file);
  }

  async handleEncryptedFileUpload(file: File) {
    return this.novaStore.handleEncryptedFileUpload(file);
  }

  continueWorkflow() {
    return this.novaStore.continueWorkflow();
  }

  private getDefaultPosition(): { x: number; y: number } {
    const screenW = window.innerWidth;
    const screenH = window.innerHeight;
    const novaWidth = 400;
    const novaHeight = 600;

    return {
      x: screenW - novaWidth - 20, // 20px de marge droite
      y: screenH - novaHeight - 80, // 80px au-dessus du dock
    };
  }

  setPosition(x: number, y: number) {
    this.position = { x, y };
  }

  toggleMinimized() {
    this.isMinimized = !this.isMinimized;
  }

  setMinimized(minimized: boolean) {
    this.isMinimized = minimized;
  }

  setProps(props: any) {
    this.props = props;
  }
}

export default NovaLocalStore;
